import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { TextField, Checkbox, FormControlLabel, Button, Card, CardContent, Typography } from '@mui/material'
import { ShopListService } from '../../services/shopListService'
import toast from 'react-hot-toast'
import PageHeader from '../PageHeader'
import { display } from '@mui/system'
import styled from '@emotion/styled'
import ShopList from './ShopList'

const EditProductForm = ({ product, setEditProduct, groupId }) => {
  const [editForm, setEditForm] = useState(product)

  const saveEditForm = async (e) => {
    try {
      e.preventDefault()
      const priceUpdate = typeof product.price === 'number' ? {} : { price: parseFloat(product.price) }
      const combinedObject = {
        ...product,
        ...priceUpdate
      }
      setEditProduct(combinedObject)
      await ShopListService.updateShopItem({ groupId, data: { ...combinedObject } })
      toast.success('Shop item updated!')
      setTimeout(() => {
        setEditProduct(null)
      }
      , 1000)
    } catch (error) {
      console.log(error)
      toast.error('Something went wrong.')
    }
  }

  const handleChange = (e) => {
    console.log('handling changev', e)
    const { name, value, type, checked } = e.target
    console.log('name ', name)
    console.log('value ', value)
    console.log('type ', type)
    console.log('checked ', checked)
    // value = [name].includes('price') ? parseFloat(value) : value
    const update = { [name]: value }
    setEditProduct((prev) => ({
      ...prev,
      ...{ [name]: type === 'checkbox' ? checked : value }
    }))
    console.log('product ', product)
  }

  const handleImageUpload = (e) => {
    const file = e.target.files[0]
    if (!file) {
      return
    }

    const reader = new FileReader()
    reader.onloadend = () => {
      setEditForm((prev) => ({
        ...prev,
        imagePayload: {
          imageString: reader.result.split(',')[1],
          encoding: 'base64',
          name: file.name
        }
      }))
    }
    reader.readAsDataURL(file)
  }

  const cancelEdit = () => {
    setEditProduct(null)
  }

  const handleDelete = async () => {
    if (product) {
      if (product.markForDelete) {
        try {
          await ShopListService.updateShopItem({ groupId, data: { ...product, markForDelete: false } })
          toast.success('Product unmarked for deletion')
          setTimeout(() => {
            setEditProduct(null)
          }
          , 1000)
        } catch (error) {
          console.error(error)
          toast.error('Failed to unmark product for deletion')
        }
      } else {
        try {
          await ShopListService.updateShopItem({ groupId, data: { ...product, markForDelete: true } })
          toast.success('Product marked for deletion')
          setTimeout(() => {
            setEditProduct(null)
          }
          , 1000)
        } catch (error) {
          console.error(error)
          toast.error('Failed to mark product for deletion')
        }
      }
    } else {
      toast.error('Product not found')
    }
  }

  return (
    product && (
      <div>
        <PageHeader title='Shop List' hideSubgroupChip />
        <Card sx={{ maxWidth: 500, mx: 'auto', p: 3, boxShadow: 3, borderRadius: 2 }}>
          <CardContent>
            <Typography variant='h6' gutterBottom>
              Product Form
            </Typography>
            <form onSubmit={saveEditForm}>
              <TextField
                label='Title'
                name='title'
                value={product.title}
                onChange={handleChange}
                fullWidth
                margin='normal'
                required
              />
              <TextField
                label='Price'
                name='price'
                type='number'
                value={product.price}
                onChange={handleChange}
                fullWidth
                margin='normal'
                required
              />
              <FormControlLabel
                control={<Checkbox checked={product.onsale} onChange={handleChange} name='onsale' />}
                label='On Sale'
              />
              <TextField
                label='URL'
                name='url'
                type='url'
                value={product.url}
                onChange={handleChange}
                fullWidth
                margin='normal'
                required
              />

              <TextField
                label='Display Weight'
                name='displayWeight'
                type='displayWeight'
                value={product.displayWeight}
                onChange={handleChange}
                fullWidth
                margin='normal'
                required
              />
              <Typography variant='body2' sx={{ mt: 2 }}>
                Upload Image
              </Typography>
              <input type='file' accept='image/*' onChange={handleImageUpload} style={{ marginTop: 8 }} />
              {product.imageString && (
                <img
                  src={product.imageString}
                  alt='Preview'
                  style={{ marginTop: 10, width: '100%', height: 160, objectFit: 'cover', borderRadius: 8 }}
                />
              )}
              <Button type='submit' variant='contained' color='primary' fullWidth sx={{ mt: 2 }}>
                Update
              </Button>
              <Button onClick={cancelEdit} variant='contained' color='primary' fullWidth sx={{ mt: 2 }}>
                Cancel
              </Button>
              <Button onClick={handleDelete} variant='contained' color='primary' fullWidth sx={{ mt: 2 }}>
                {product.markForDelete ? 'Un-Delete' : 'Mark for Delete'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    )
  )
}

export default EditProductForm
